import { render } from "./AuthMenu.vue?vue&type=template&id=9d0e2bda"
import script from "./AuthMenu.vue?vue&type=script&lang=js"
export * from "./AuthMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/wordpressswitchlitseptemberdevnl/wordpress.switchlit.septemberdev.nl/web/app/themes/switchlit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__